import api from './api';
import { API_ENDPOINTS } from './endpoints';

export interface DashboardData {
    cards: {
        sales: { value: number; count: number; last_month: number; diff: number };
        customers: { value: number; last_month: number; diff: number };
        cancelled: { value: number; last_month: number; diff: number };
        total_orders: { value: number; last_month: number; diff: number };
    };
    chart: {
        labels: string[];
        current: number[];
        previous: number[];
        totals: {
            current: number;
            previous: number;
        };
        period: {
            current: string;
            previous: string;
        };
    };
    donut: {
        sold: { value: number; count: number };
        cancelled: { value: number; count: number };
    };
}

export const dashboardService = {
    getDashboardData: (params?: { start_date?: string; end_date?: string; period_type?: string }) => api.get<DashboardData>(API_ENDPOINTS.DASHBOARD.INDEX, { params }),
};
